/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />




namespace Application.Services {
    'use strict';


    /**
     * BlockConnectionBlocksService
     */

    import IUpdateBlockConnection = Application.Models.IUpdateBlockConnection;
    export class BlockConnectionBlocksService {

        public static $name: string = 'blockConnectionBlocksService';
        public static $inject: string[] = ['$http', 'backendService', '$q', '$timeout'];


        private backendBaseUrl: string = window.backendUrl;
        private servicePath: string = '';
        private blockConnectionBlocksBackendUrl: string = this.backendBaseUrl + this.servicePath + 'blockConnections/';


        constructor(private $http: ng.IHttpService,
                    private backendService: BackendService) {
        }

        public updateBlockConnection(blockConnection: IUpdateBlockConnection): ng.IPromise<IBlockConnection[]> {
            const blockConnectionId: number = blockConnection.id;
            return this.backendService.put(this.blockConnectionBlocksBackendUrl + blockConnectionId, blockConnection).then(
                (response: ng.IHttpPromiseCallbackArg<IBlockConnection[]>) => {
                    return response.data;

                });


        }


    }
}